<template>
    <div id="main_div">
        <section class="details-product">
            <div class="container">
        <div v-if="isLoading" class="skeleton-loader-container mt-4">
          <div class="card shadow p-4 mb-5 bg-white rounded">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="skeleton-pulse skeleton-btn"></div>
              <div class="skeleton-pulse skeleton-title mx-auto"></div>
            </div>
            <hr />
            <div class="skeleton-pulse skeleton-section-title mb-3"></div>
            <div class="d-flex flex-wrap">
              <div class="data-item" v-for="i in 6" :key="i">
                <div class="skeleton-pulse skeleton-label mb-2"></div>
                <div class="skeleton-pulse skeleton-value"></div>
              </div>
            </div>
            <hr />
            <div class="skeleton-pulse skeleton-section-title mb-3"></div>
            <div class="d-flex flex-wrap">
              <div class="data-item" v-for="i in 9" :key="i">
                <div class="skeleton-pulse skeleton-label mb-2"></div>
                <div class="skeleton-pulse skeleton-value"></div>
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-around mb-4">
              <div class="skeleton-pulse skeleton-img"></div>
              <div class="skeleton-pulse skeleton-img"></div>
            </div>
          </div>
        </div>
                <div v-else class="row">
                    <div class="col-md mt-4">
                        <div class="details-product__content">
                            <b-card class="card shadow p-3 mb-5 bg-white rounded">
                                <b-col cols="4">
                                    <b-link class="text-left h4" @click="$router.go(-1)">
                                        <b-icon icon="chevron-left" style="width: 25px; height: 25px;"></b-icon>
                                        Kembali
                                    </b-link>
                                </b-col>
                                <h2 class="font-weight-bold text-center">Detail Nasabah</h2>
                                <hr />
                                <div class="d-flex justify-content-around align-items-center mb-3">
                                    <!-- Foto KTP Section -->
                                    <div class="text-center flex-fill mx-2">
                                        <h4 class="mb-2">Foto KTP</h4>
                                        <img v-if="items && items.profile && items.profile.foto_ktp"
                                            :src="items.profile.foto_ktp"
                                            alt="Foto KTP" class="img-fluid mb-3"
                                            style="max-height: 200px; object-fit: cover; border-radius: 8px;" />
                                        <span v-else class="text-muted">Tidak ada foto KTP</span>
                                    </div>

                                    <!-- Foto Selfie Section -->
                                    <div class="text-center flex-fill mx-2">
                                        <h4 class="mb-2">Foto Selfie</h4>
                                        <img v-if="items && items.profile && items.profile.foto_selfie"
                                            :src="items.profile.foto_selfie"
                                            alt="Foto Selfie" class="img-fluid mb-3"
                                            style="max-height: 200px; object-fit: cover; border-radius: 8px;" />
                                        <span v-else class="text-muted">Tidak ada foto selfie</span>
                                    </div>
                                </div>
                                <hr />
                                <h4>e-KYC</h4>
                                <div class="d-flex flex-wrap">
                                    <!-- Status Sertifikasi -->
                                    <div class="data-item">
                                        <h5>Status Sertifikasi</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ convertCertificationStatus(items.user_tilaka.cer_status) }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Status Registrasi -->
                                    <div class="data-item">
                                        <h5>Status Registrasi</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ convertStatus(items.user_tilaka.reg_status) }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Verifikasi NIK -->
                                    <div class="data-item">
                                        <h5>Verifikasi NIK</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ items.user_tilaka.reg_nik ? "✅ Valid" : "❌ Tidak Valid" }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Verifikasi Nama -->
                                    <div class="data-item">
                                        <h5>Verifikasi Nama</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ items.user_tilaka.reg_nama ? "✅ Valid" : "❌ Tidak Valid" }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- FR Score -->
                                    <div class="data-item">
                                        <h5>FR Score</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ items.user_tilaka.reg_fr_score }} ({{ items.user_tilaka.reg_fr_score_percentage }}%) - 
                                            <strong>{{ convertFRScore(items.user_tilaka.reg_fr_score, items.user_tilaka.reg_fr_score_percentage) }}</strong>
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Hasil Liveness -->
                                    <div class="data-item">
                                        <h5>Hasil Liveness</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ items.user_tilaka.reg_liveness_result ? "✅ Lolos" : "❌ Gagal" }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Hasil Akhir Verifikasi -->
                                    <div class="data-item">
                                        <h5>Ringkasan Verifikasi</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ items.user_tilaka.reg_summary_verification_result ? "✅ Berhasil" : "❌ Gagal" }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Kode Alasan -->
                                    <div class="data-item">
                                        <h5>Status e-KYC</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ convertReasonCode(items.user_tilaka.reg_reason_code) }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>

                                    <!-- Status Registrasi Manual -->
                                    <div class="data-item">
                                        <h5>Status Registrasi Manual</h5>
                                        <span v-if="items && items.user_tilaka && items.is_deleted !== true">
                                            {{ convertManualRegistration(items.user_tilaka.reg_manual_registration_status) }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                                <hr />
                                <h4>Data Diri Nasabah</h4>
                                <div class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>Nama Lengkap</h5>
                                        <span v-if="items && items.name != null">{{ items.name }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Jenis Kelamin</h5>
                                        <span v-if="items && items.profile && items.profile.jenis_kelamin != null">{{
                                            formatCapitalized(items.profile.jenis_kelamin)
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Agama</h5>
                                        <span>{{ items && items.profile ? formatUpperCase(items.profile.agama) : "-" }}</span>
                                    </div>

                                    <div class="data-item">
                                        <h5>Nomor Tanda Pengenal</h5>
                                        <MaskingViewData 
                                            v-if="items && items.profile && items.profile.nomor_tanda_pengenal && items.profile.jenis_tanda_pengenal" 
                                            :value="items.profile.jenis_tanda_pengenal + ' - ' + items.profile.nomor_tanda_pengenal" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Tempat Diterbitkan</h5>
                                        <span>{{ items && items.profile ? items.profile.tempat_diterbitkan : "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Masa Berlaku Tanda Pengenal</h5>
                                        <span>{{
                                        items && items.profile ? formatUpperCase(items.profile.masa_berlaku_tanda_pengenal) : "-"
                                        }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Nomor NPWP</h5>
                                        <MaskingViewData 
                                        v-if="items && items.profile && items.profile.npwp" 
                                        :value="items.profile.npwp" />
                                        <span v-else>-</span>
                                        <a
                                        v-if="
                                            items &&
                                            items.profile &&
                                            items.profile.npwp_attachment
                                        "
                                        :href="
                                            items.profile.npwp_attachment
                                        "
                                        target="_blank"
                                        class="d-flex align-items-center mt-3"
                                        >
                                        <b-img
                                            :src="require('@/assets/images/icon/icon-pdf.png')"
                                            alt="PDF"
                                            style="max-width: 100px"
                                        />
                                        <span class="ml-2">Klik untuk membuka file PDF</span>
                                        </a>
                                    </div>

                                    <div class="data-item">
                                        <h5>Kewarganegaraan</h5>
                                        <span>{{
                                        items && items.profile && items.profile.kewarganegaraan ? items.profile.kewarganegaraan.toUpperCase() : "-"
                                        }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Status Pernikahan</h5>
                                        <span>{{
                                        items && items.profile ? formatUpperCase(items.profile.status_pernikahan) : "-"
                                        }}</span>
                                    </div>

                                    <div class="data-item">
                                        <h5>Pendidikan</h5>
                                        <span>{{ items && items.profile ? formatUpperCase(items.profile.pendidikan) : "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>No. Ponsel yang terhubung ke WA</h5>
                                        <MaskingViewData 
                                        v-if="items && items.no_telpon" 
                                        :value="items.no_telpon" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item" v-if="items && items.profile && items.profile.no_hp_alternatif">
                                        <h5>No. Telepon/HP Alternatif</h5>
                                        <MaskingViewData 
                                        v-if="items && items.profile && items.profile.no_hp_alternatif" 
                                        :value="items.profile.no_hp_alternatif" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Tempat Lahir</h5>
                                        <span>{{ items && items.profile ? items.profile.tempat_lahir : "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Tanggal Lahir</h5>
                                        <MaskingViewData 
                                        v-if="items && items.profile && items.profile.tanggal_lahir" 
                                        :value="tanggal_lahir_parsed" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item"></div>
                                    <div
                                        class="data-item"
                                        v-if="!(items && items.profile && items.profile.no_hp_alternatif)"
                                    ></div>
                                    </div>
                                    <hr />
                                    <div class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>Alamat Sesuai KTP</h5>
                                        <MaskingViewData 
                                        v-if="items && items.profile && items.profile.alamat" 
                                        :value="items.profile.alamat" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kelurahan</h5>
                                        <span>{{ kelurahan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kecamatan</h5>
                                        <span>{{ kecamatan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kabupaten/Kota</h5>
                                        <span>{{ kota_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Provinsi</h5>
                                        <span>{{ provinsi_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Negara</h5>
                                        <span>{{ items && items.profile ? items.profile.negara : "-" }}</span>
                                    </div>
                                    </div>
                                    <hr />
                                    <div class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>alamat Domisili</h5>
                                        <MaskingViewData 
                                        v-if="items && items.profile && items.profile.alamat" 
                                        :value="items.profile.alamat" />
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kelurahan</h5>
                                        <span v-if="kelurahan_ktp_parsed != null && kelurahan_ktp_parsed !== ''">{{
                                        kelurahan_ktp_parsed
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kecamatan</h5>
                                        <span v-if="kecamatan_ktp_parsed != null && kecamatan_ktp_parsed !== ''">{{
                                        kecamatan_ktp_parsed
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kabupaten/Kota</h5>
                                        <span v-if="kota_ktp_parsed != null && kota_ktp_parsed !== ''">{{
                                        kota_ktp_parsed
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Provinsi</h5>
                                        <span v-if="provinsi_ktp_parsed != null && provinsi_ktp_parsed !== ''">{{
                                        provinsi_ktp_parsed
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Negara</h5>
                                        <span v-if="items && items.profile && items.profile.negara != null">{{
                                        items.profile.negara
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Status Tempat Tinggal</h5>
                                        <span v-if="items && items.profile && items.profile.status_tempat_tinggal != null">{{
                                        formatCapitalized(items.profile.status_tempat_tinggal)
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    </div>
                                <hr />
                                <div class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>Nama Ahli Waris</h5>
                                        <span v-if="items && items.profile && items.profile.nama_pihak_terkait != null">{{
                                            items.profile.nama_pihak_terkait
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Hubungan</h5>
                                        <span v-if="items && items.profile && items.profile.hubungan_pihak_terkait != null">{{
                                            items.profile.hubungan_pihak_terkait
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Alamat Ahli Waris</h5>
                                        <span v-if="items && items.profile && items.profile.alamat_pihak_terkait != null">{{
                                            items.profile.alamat_pihak_terkait
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>No HP Ahli Waris</h5>
                                        <span v-if="items && items.profile && items.profile.no_hp_pihak_terkait != null">{{
                                            items.profile.no_hp_pihak_terkait
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Perkiraan Nilai Transaksi Dalam 1 Tahun</h5>
                                        <span v-if="items && items.profile && items.profile.perkiraan_nilai_transaksi != null">{{
                                            items.profile.perkiraan_nilai_transaksi }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item"></div>
                                </div>

                                <hr />
                                <h4>Data Pekerjaan</h4>
                                <div class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>Jenis Pekerjaan</h5>
                                        <span v-if="items && items.data_pekerjaan && items.data_pekerjaan.jenis_pekerjaan != null">{{
                                            items.data_pekerjaan.jenis_pekerjaan
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div v-if="items && items.data_pekerjaan && items.data_pekerjaan.bidang_usaha_id != null" class="data-item">
                                        <h5>Bidang Usaha</h5>
                                        <span>{{ items.data_pekerjaan.bidang_usaha_id }}</span>
                                    </div>
                                    <div v-if="items && items.data_pekerjaan && items.data_pekerjaan.jabatan != null" class="data-item">
                                        <h5>Jabatan</h5>
                                        <span>{{ items.data_pekerjaan.jabatan }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Nama Tempat Bekerja</h5>
                                        <span v-if="items && items.data_pekerjaan && items.data_pekerjaan.nama_tempatkerja != null">{{
                                            items.data_pekerjaan.nama_tempatkerja }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Alamat Tempat Bekerja</h5>
                                        <span v-if="items && items.data_pekerjaan && items.data_pekerjaan.alamat_tempatkerja != null">{{
                                            items.data_pekerjaan.alamat_tempatkerja }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kelurahan</h5>
                                        <span>{{ kelurahan_pekerjaan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kecamatan</h5>
                                        <span>{{ kecamatan_pekerjaan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Kabupaten/Kota</h5>
                                        <span>{{ kota_pekerjaan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Provinsi</h5>
                                        <span>{{ provinsi_pekerjaan_parsed || "-" }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Negara</h5>
                                        <span v-if="items && items.data_pekerjaan && items.data_pekerjaan.negara != null">{{
                                            items.data_pekerjaan.negara
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>No Telp Tempat Bekerja</h5>
                                        <span v-if="items && items.data_pekerjaan && items.data_pekerjaan.no_telpon != null">{{
                                            items.data_pekerjaan.no_telpon
                                            }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Rata-rata Penghasilan Dalam 1 Bulan</h5>
                                        <span v-if="
                                            items &&
                                            items.data_pekerjaan &&
                                            items.data_pekerjaan.ratarata_penghasilan_perbulan !=
                                            null
                                        ">{{
                                            items.data_pekerjaan.ratarata_penghasilan_perbulan
                                        }}</span>
                                        <span v-else>-</span>
                                    </div>
                                    <div class="data-item"></div>
                                </div>
                                <hr />
                                <h4>Data Rekening</h4>
                                <div v-if="items && items.user_bank" class="d-flex flex-wrap">
                                    <div class="data-item">
                                        <h5>Nama Bank</h5>
                                        <span>{{ (items.user_bank.bank && items.user_bank.bank.name) || '-' }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Nomor Rekening</h5>
                                        <span>{{ items.user_bank.account_number || '-' }}</span>
                                    </div>
                                    <div class="data-item">
                                        <h5>Nama Pemilik Rekening</h5>
                                        <span>{{ items.user_bank.account_name || '-' }}</span>
                                    </div>
                                </div>
                                <!-- If no bank data -->
                                <div v-else class="text-center mt-3">
                                    <h5 class="font-weight-bold text-danger mt-0">
                                        Data rekening tidak tersedia
                                    </h5>
                                </div>
                                <hr />
                                <div class="text-center mb-3">
                                    <b-button 
                                        @click="downloadPDF" 
                                        class="font-weight-bold btn-custom"
                                        :disabled="isDownloading">
                                        <b-spinner v-if="isDownloading" small label="Downloading..."></b-spinner>
                                        <span v-else>Download PDF</span>
                                    </b-button>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <Footer /> -->
        <js />
        <!-- Modal Nasabah Dihapus -->
        <b-modal
          v-model="showDeletedModal"
          centered
          hide-header
          hide-footer
          no-close-on-backdrop
          no-close-on-esc
        >
          <div class="text-center p-4">
            <div class="mb-3">
              <b-icon
                icon="exclamation-triangle-fill"
                variant="warning"
                style="width: 60px; height: 60px"
              ></b-icon>
            </div>
            <h4 class="font-weight-bold text-dark mb-3">Informasi Nasabah</h4>
            <p class="text-muted mb-4">
              Nasabah ini telah dihapus karena Kebijakan Privasi (Retensi Data)
            </p>
            <b-button
              variant="primary"
              class="btn-custom px-4 py-2"
              @click="showDeletedModal = false"
            >
              Tutup
            </b-button>
          </div>
        </b-modal>
    </div>
</template>

<script>
import Funder from "../../api/funder.js";
import provinsi from "../../api/daerahindonesia/provinsi.js";
import kelurahan from "../../api/daerahindonesia/kelurahan.js";
import kecamatan from "../../api/daerahindonesia/kecamatan.js";
import MaskingViewData from "../../components/masking-view-data.vue"
import kota from "../../api/daerahindonesia/kota.js";

export default {
    name: "ShowFunder",
    components: {
    MaskingViewData,
  },
    data() {
        return {
            isLoading: true,
            isDownloading: false,
            showDeletedModal: false,
            items: [],
            apiUrl: process.env.API_URL,
            kelurahan_parsed: "",
            kecamatan_parsed: "",
            kota_parsed: "",
            provinsi_parsed: "",
            kelurahan_ktp_parsed: "",
            kecamatan_ktp_parsed: "",
            kota_ktp_parsed: "",
            provinsi_ktp_parsed: "",
            kelurahan_pekerjaan_parsed: "",
            kecamatan_pekerjaan_parsed: "",
            kota_pekerjaan_parsed: "",
            provinsi_pekerjaan_parsed: "",
            tanggal_lahir_parsed: ''
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        safeGet(obj, path) {
            return path.split(".").reduce((acc, key) => acc && acc[key], obj);
        },
        viewNPWPPDF(filename) {
            const pdfUrl = `${this.apiUrl}/storage/user-profile/${filename}`;
            window.open(pdfUrl, "_blank");
        },

        convertCertificationStatus(status) {
            const certStatusMap = {
                "0": "❌ Tidak Ada Sertifikat",
                "1": "⏳ Dalam Proses Verifikasi",
                "2": "📝 Sertifikat Terbit (Menunggu Konfirmasi User)",
                "3": "✅ Sertifikat Aktif",
                "4": "❌ Sertifikat Ditolak oleh Validator"
            };
            return certStatusMap[status] || "-";
        },

        // Konversi Status Registrasi
        convertStatus(status) {
            const statusMap = {
                "S": "✅ Sukses",
                "F": "❌ Gagal (Data tidak sesuai dengan Dukcapil)",
                "E": "⚠️ Error (Gagal koneksi ke Dukcapil)",
                "B": "⏳ Masih dalam tahap verifikasi",
                "D": "📝 Masih dalam tahap pengisian form"
            };
        return statusMap[status] || "-";
        },

        // Konversi FR Score dan Percentage
        convertFRScore(score, percentage) {
            if (score === "A" || (score === "B" && percentage >= 75.00)) {
                return "✅ Lolos Dukcapil";
            } else if (score === "C" && percentage >= 50.00) {
                return "❌ Tidak Lolos Dukcapil";
            } else if (score === "D" || percentage < 50.00) {
                return "❌ Tidak Lolos Dukcapil";
            }
            return "-";
        },

        // Konversi Reason Code
        convertReasonCode(code) {
            const reasonMap = {
                "0": "✅ Sukses e-KYC",
                "1": "❌ Gagal Dukcapil (Data tidak sesuai)",
                "2": "❌ Liveness Gagal",
                "3": "⚠️ Register ID Expired"
            };
            return reasonMap[code] || "-";
        },

        // Konversi Manual Registration Status
        convertManualRegistration(status) {
            const manualMap = {
                "P": "⏳ Belum Memulai Manual Registration",
                "I": "📝 Sedang Mengisi Form Manual Registration",
                "V": "🔍 Sedang Diverifikasi Tilaka",
                "S": "✅ Manual Registration Sukses",
                "F": "❌ Manual Registration Gagal",
                "E": "⚠️ Register ID Expired"
            };
            return manualMap[status] || "-";
        },

        formatRupiah(value) {
            // Menghilangkan angka di belakang koma
            const cleanValue = Math.floor(parseFloat(value)); // Buang desimal

            if (!cleanValue) return "Rp. 0";
            const numberString = cleanValue
                .toString()
                .replace(/[^,\d]/g, "")
                .toString();
            let rest = numberString.length % 3;
            let rupiah = numberString.substr(0, rest);
            const thousand = numberString.substr(rest).match(/\d{3}/gi);

            if (thousand) {
                const separator = rest ? "." : "";
                rupiah += separator + thousand.join(".");
            }

            return "Rp. " + rupiah;
        },
        formatDateIndonesian(date) {
            if (!date) return "";
            const [ year, month, day ] = date.split("-");
            const monthNames = [
                "Januari",
                "Februari",
                "Maret",
                "April",
                "Mei",
                "Juni",
                "Juli",
                "Agustus",
                "September",
                "Oktober",
                "November",
                "Desember"
            ];
            return `${day} ${monthNames[ parseInt(month, 10) - 1 ]} ${year}`;
        },
        formatCapitalized(status) {
            if (!status) return "-";
            return status
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
        },
        formatUpperCase(status) {
            if (!status) return "-";
            return status
                .replace(/_/g, " ")
                .replace(/\b\w/g, char => char.toUpperCase());
        },
        loadData() {
            this.isLoading = true;
            const funderId = this.$route.params.funderId;

            Funder.showV3(funderId)
                .then(res => {
                    this.items = res.data.data.user || {};
                    console.log("response show : ", this.items);
                    if (this.items && this.items.is_deleted === true) {
                        this.showDeletedModal = true;
                    }
                    const profile = this.items.profile || {};
                    const dataPekerjaan = this.items.data_pekerjaan || {};

                    this.tanggal_lahir_parsed = profile.tanggal_lahir
                        ? this.formatDateIndonesian(profile.tanggal_lahir)
                        : "";
                    // Muat lokasi untuk alamat, KTP, dan pekerjaan
                    this.loadLokasi(
                        profile.kelurahan,
                        profile.kecamatan,
                        profile.kota,
                        profile.provinsi,
                        false
                    );

                    this.loadLokasi(
                        profile.kelurahan_ktp,
                        profile.kecamatan_ktp,
                        profile.kota_ktp,
                        profile.provinsi_ktp,
                        true
                    );

                    this.loadLokasi(
                        dataPekerjaan.kelurahan,
                        dataPekerjaan.kecamatan,
                        dataPekerjaan.kota,
                        dataPekerjaan.provinsi,
                        false,
                        true
                    );
                })
                .catch(error => {
                    console.error('Error loading funder data:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadLokasi(
            kodeKelurahan,
            kodeKecamatan,
            kodeKota,
            kodeProvinsi,
            isKtp,
            isWorkAddress = false
        ) {
            if (kodeProvinsi) {
                this.loadProvinsi(kodeProvinsi, isKtp, isWorkAddress);
            }
            if (kodeKota) {
                this.loadKota(kodeKota, isKtp, isWorkAddress);
            }
            if (kodeKecamatan) {
                this.loadKecamatan(kodeKecamatan, isKtp, isWorkAddress);
            }
            if (kodeKelurahan) {
                this.loadKelurahan(kodeKelurahan, isKtp, isWorkAddress);
            }
        },

        loadProvinsi(kodeProvinsi, isKtp, isWorkAddress) {
            provinsi.show(kodeProvinsi).then(response => {
                this.namaProvinsi = response.data.data.name;
                if (isKtp) {
                    this.provinsi_ktp_parsed = this.namaProvinsi;
                } else if (isWorkAddress) {
                    this.provinsi_pekerjaan_parsed = this.namaProvinsi;
                } else {
                    this.provinsi_parsed = this.namaProvinsi;
                }
                // console.log("ini provin", this.namaProvinsi);
            });
        },

        loadKota(kodeKota, isKtp, isWorkAddress) {
            kota.show(kodeKota).then(response => {
                this.namaKota = response.data.data.name;
                if (isKtp) {
                    this.kota_ktp_parsed = this.namaKota;
                } else if (isWorkAddress) {
                    this.kota_pekerjaan_parsed = this.namaKota;
                } else {
                    this.kota_parsed = this.namaKota;
                }
                // console.log("ini kota", this.namaKota);
            });
        },

        loadKecamatan(kodeKecamatan, isKtp, isWorkAddress) {
            kecamatan.show(kodeKecamatan).then(response => {
                this.namaKecamatan = response.data.data.name;
                if (isKtp) {
                    this.kecamatan_ktp_parsed = this.namaKecamatan;
                } else if (isWorkAddress) {
                    this.kecamatan_pekerjaan_parsed = this.namaKecamatan;
                } else {
                    this.kecamatan_parsed = this.namaKecamatan;
                }
                // console.log("ini kecamatan", this.namaKecamatan);
            });
        },

        loadKelurahan(kodeKelurahan, isKtp, isWorkAddress) {
            kelurahan.show(kodeKelurahan).then(response => {
                this.namaKelurahan = response.data.data.name;
                if (isKtp) {
                    this.kelurahan_ktp_parsed = this.namaKelurahan;
                } else if (isWorkAddress) {
                    this.kelurahan_pekerjaan_parsed = this.namaKelurahan;
                } else {
                    this.kelurahan_parsed = this.namaKelurahan;
                }
                // console.log("ini kelurahan", this.namaKelurahan);
            });
        },
        async downloadPDF() {
            this.isDownloading = true;
            try {
                const response = await Funder.downloadFunder(this.$route.params.funderId);

                if (response && response.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'funder_on_mitra.pdf');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } else {
                    console.error('Failed to download file: Unexpected response status', response.status);
                }
            } catch (error) {
                console.error('Error downloading the file:', error);
            } finally {
                this.isDownloading = false;
            }
        }
    }
};
</script>

<style>
.d-flex {
    display: flex;
    flex-wrap: wrap;
}

.data-item {
    flex: 1 0 30%;
    /* Flex-grow, flex-shrink, flex-basis */
    margin-right: 1.5rem;
    /* Space between items */
    margin-bottom: 1rem;
    /* Space below items */
}

.data-item:nth-child(3n) {
    margin-right: 0;
    /* Remove margin for every third item */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}

/* Skeleton Loading Animation Styles */
.skeleton-pulse {
  background: linear-gradient(-90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%);
  background-size: 400% 400%;
  animation: pulse 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.skeleton-btn {
  width: 100px;
  height: 35px;
}

.skeleton-title {
  width: 280px;
  height: 40px;
}

.skeleton-section-title {
  width: 160px;
  height: 28px;
}

.skeleton-label {
  width: 120px;
  height: 18px;
}

.skeleton-value {
  width: 80%;
  height: 24px;
}

.skeleton-img {
  width: 200px;
  height: 200px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/public/dashboard/show-funder.vue